// New Voucher component
import React, { useState, useEffect, useRef, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import "./voucher.css";
import {
  ChangeMode,
  Configure,
  DispatchDetails,
  OrderDetails,
  OtherVoucher,
  Period,
  VoucherTypeNameSelect,
} from "./voucher_modal/Index";
import {
  voucherTypeList,
  contraLedgerListing,
  serialNumberList,
  contraVoucherCreate,
  storeVoucherEntryData,
  numberSeriesList,
  godownList,
  stockItemList,
  filterVoucherTypeData,
  openModal,
  closeModal,
  contraVoucherSingle,
} from "../../../redux/actions/action-creator";

import {
  dateFormateSend,
  dateFormateShow,
  dateDayShow,
  currencyFormate,
  removeCurrencyComma,
  datePayment_func,
  getVoucherDate,
  getDateInFormate,
} from "../../../components/Date_Formate_Utilitiy/Index";
import Contra from "./Voucher/Contra";
import RecieptPayment from "./Voucher/RecieptPayment";
import HomeLayout from "../../../components/home_page/HomeLayout";
import Sales from "./Voucher/Sales";
import Purchase from "./Voucher/Purchase";
import { useInputActionVoucher } from "../../../components/Custom_Hooks/useInputActionVoucher";
import {
  prepareFormData,
  useFormHandler,
} from "../../../components/Custom_Hooks/useFormHandler";
import useClickOutside from "../../../components/Custom_Hooks/useClickOutsSide";
import LedgerCreate from "../master/create/accounting_masters/Ledger";
import GodownCreate from "../master/create/Inventory_masters/GoDown";
import StockItemCreate from "../master/create/Inventory_masters/StockItem";
import Indicator from "../../../components/Indicator/Indicator";
import Journal from "./Voucher/Journal";
import { useParams } from "react-router-dom";

let filter_voucher = [];

const Vouchers = React.memo(() => {
 
  const dispatch = useDispatch();
  const { id } = useParams();

  // get state data from redux
  const { userData } = useSelector((state) => state.auth);
  const { voucher_type_data = null } = useSelector((state) => state.common);
  const { company_session } = useSelector((state) => state.common);
  const modal_state = useSelector((state) => state.common.modal_state);

  const date_formated_send = dateFormateSend(company_session?.current_date);
  const date_formated_show = dateFormateShow(company_session?.current_date);
  const date_day_show = dateDayShow(date_formated_show);
  const [loading_voucher, setLoading_voucher] = useState(false);

  // Memoize getLastUsedVoucherData to prevent unnecessary re-renders
  const getLastUsedVoucherData = useCallback(() => {
    const lastUsedData = localStorage.getItem("lastUsedVoucherData");

    if (lastUsedData && voucher_type_data && voucher_type_data.length > 0) {
      try {
        const { voucher_type_id, voucher_number_series_id } =
          JSON.parse(lastUsedData);

        const selectedVoucherType = voucher_type_data?.find(
          (v) => v.id === voucher_type_id
        );
        const selectedNumberSeries =
          selectedVoucherType?.vaucher_number_series_data?.find(
            (n) => n.id === voucher_number_series_id
          );

        if (selectedVoucherType && selectedNumberSeries) {
          return {
            voucher_type_name: selectedVoucherType.voucher_type_name,
            voucher_type_id: selectedVoucherType.id,
            voucher_number_series_id: selectedNumberSeries.id,
          };
        }
      } catch (error) {
        console.error("Error parsing lastUsedVoucherData:", error);
      }
    }
    return {
      voucher_type_name: voucher_type_data?.[0]?.voucher_type_name || "",
      voucher_type_id: voucher_type_data?.[0]?.id || "",
      voucher_number_series_id:
        voucher_type_data?.[0]?.vaucher_number_series_data?.[0]?.id || "",
    };
  }, [voucher_type_data]);

  const initialState = {
    voucher_type_name: "",
    voucher_type_id: "",
    voucher_number_series_id: "",
    select_type_of_voucher: "",
    serial_no: "",
    total_amount: "",
    company_id: userData?.id,
    create_date: date_formated_show,
    day_name: date_day_show,
    is_checked_series: "1",
    narration: "",
    account: "",
    account_ledger_id: "",
    account_ledger_balance: "",
    data: [
      {
        id: "1",
        first: "",
        particular_ledger_balance: "",
        particular_ledger_id: "",
        particular_ledger_pay_amount: "",
      },
    ],
    is_proceed: "1",
    supplier_ref_no: "",
    party_bill_to: "",
    party_bill_to_ledger_id: "",
    partry_bill_to_current_balance: "",
    data_item: [
      {
        id: "1",
        item_name: "",
        item_id: "",
        godown_location: "",
        godown_location_id: "",
        item_qty: "",
        item_rate: "",
        per_unit: "",
        item_amt: "",
        item_alternate_unit: "",
        is_unit_available: false,
        where_unit_num: "",
        where_alternate_unit_num: "",
        main_unit_name: "",
        combination_of_units: "",
        check_open: false,
        total_nos_box: "",
        total_no_box_unit: "",
      },
    ],

    sale_ledger_data: [
      {
        id: "1",
        ledger_account: "",
        ledger_account_id: "",
        rate_percentage: "",
        ledger_amount: "",
        check: false,
      },
    ],
    payment_allocation: [
      {
        id: "1",
        payment_ledger_account: "",
        payment_ledger_account_id: "",
        payment_ledger_amount: "",
      },
    ],
    party_bill_to_mailing_name: "",
    bill_to_address: "",
    bill_to_contact: "",

    party_ship_to: "",
    party_ship_to_ledger_id: "",
    party_ship_to_current_balance: "",
    party_ship_to_mailing_name: "",
    ship_to_address: "",
    ship_to_contact: "",

    sale_purchase_ledger_account: "",
    sales_ledger_order_id: "",
    sale_purchase_ledger_current_balance: "",
    dispatch_detail: "Not Available",
    voucher_type: "",
    delivery_note_no: "",
    dispatch_doc_no: "",
    dispatch_through: "",
    destination: "",
    carrier_name_agent: "",
    bill_of_loading: "",
    dispatch_date: "",
    order_detail: "Not Available",
    order_no: "",
    mode_term_payment: "",
    other_reference: "",
    term_of_delivery: "",

    location: "",
    location_id: "",

    bank_ac_od_ledger: "",
    bank_account_od_ledger: "",
    bank_ac_amt: "",
    UTR_CHQ: "",

    cash_in_hand_ledger: "",
    cash_in_hand_ledger_name: "",
    cash_in_hand_amt: "",
    cash_tendered: "",
    balance: "",

    sundry_debitor_ledger: "",
    sundry_debitor_amt: "",
    sundry_debitor_ledger_name: "",
    tran_id: "",

    party_account_ledger: "",
    party_account_name: "",
    party_amount: "",
    party_balance: "",
    total_item_amt: "",

    date_payment: "",

    check_num_series_manual_automatic: "",
    is_unit_available: "",
    where_unit_num: "",
    where_alternate_unit_num: "",
    alternate_unit_name: "",
    main_unit_name: "",
    combination_of_units: "",
    total_amount_item: "",
    total_amount_allocate_party: "",
  };
  const [data, setData] = useState(initialState);

  const [contra_account_ledger_list, setcontra_account_ledger_list] = useState(
    []
  );
  const [itemData, setItemData] = useState([]);
  const [godownLocation, setgodownLocation] = useState([]);
  const [godownLocationItem, setgodownLocationItem] = useState([]);
  const [itemLedgerData, setItemLedgerData] = useState([]);
  const [itemLedgerPurchaseData, setItemLedgerPurchaseData] = useState([]);
  const [bankAccountOdLedger, setbankAccountOdLedger] = useState([]);
  const [cashInHandLedger, setcashInHandLedger] = useState([]);
  const [sundryDebCredLedger, setsundryDebCredLedger] = useState([]);
  const [payment_allocation_ledger_list, setpayment_allocation_ledger_list] = useState([]);
  const [receipt_particular_ledger_list, setreceipt_particular_ledger_list] =
    useState([]);
  const [
    party_bill_and_ship_to_ledger_list,
    setparty_bill_and_ship_to_ledger_list,
  ] = useState([]);
  const [sales_ledger_list, setsales_ledger_list] = useState([]);
  const [purchase_ledger_list, setpurchase_ledger_list] = useState([]);
  // Add new loading states
  const [loadingStates, setLoadingStates] = useState({
    vouchers: true,
    stock: true,
    ledgers: true,
  });


  const MAX_RETRIES = 3;
  const [nameInput, setNameInput] = useState(null);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);

  const inputRefs = {
    voucher_type_name: useRef(null),
    serial_no: useRef(null),
    create_date: useRef(null),
    account: useRef(null),
    narration: useRef(null),
  };
  const inputRefs_reciept = {
    voucher_type_name: useRef(null),
    serial_no: useRef(null),
    create_date: useRef(null),
    supplier_inv_ref: useRef(null),
    date_payment: useRef(null),
    account: useRef(null),
    narration: useRef(null),
  };
  const inputRefs_sales = {
    voucher_type_name: useRef(null),
    serial_no: useRef(null),
    create_date: useRef(null),
    supplier_ref_no: useRef(null),
    date_payment: useRef(null),
    party_bill_to: useRef(null),
    party_bill_to_mailing_name: useRef(null),
    bill_to_address: useRef(null),
    bill_to_contact: useRef(null),
    party_ship_to: useRef(null),
    party_ship_to_mailing_name: useRef(null),
    ship_to_address: useRef(null),
    ship_to_contact: useRef(null),
    location: useRef(null),
    sale_purchase_ledger_account: useRef(null),
    dispatch_detail: useRef(null),
    delivery_note_no: useRef(null),
    dispatch_doc_no: useRef(null),
    dispatch_through: useRef(null),
    destination: useRef(null),
    carrier_name_agent: useRef(null),
    bill_of_loading: useRef(null),
    dispatch_date: useRef(null),
    order_detail: useRef(null),
    order_no: useRef(null),
    mode_term_payment: useRef(null),
    other_reference: useRef(null),
    term_of_delivery: useRef(null),
    narration: useRef(null),
  };
  const dynamicInputRef = useRef({});
  const dynamicInputRef_sales = useRef({});
  const dynamicInputRef_payment_allocation = useRef({});

  function getCurrentInputRef(name) {
    return inputRefs[name] || null;
  }
  // Modified first useEffect for better error handling and loading states
  useEffect(() => {
    const loadInitialData = async () => {
      if (!userData?.id) return;
      
      setLoadingStates((prev) => ({ ...prev, vouchers: true }));

      try {
        let voucherTypeResponse;

        // Check if voucher_type_data is already loaded
        if (voucher_type_data && voucher_type_data.length > 0) {
          voucherTypeResponse = { data: voucher_type_data };
        } else {
          const formdata = new FormData();
          formdata.append("company_id", userData?.id);

          voucherTypeResponse = await dispatch(voucherTypeList(formdata));

          console.log(voucherTypeResponse, "voucherTypeResponse");
        }

        // Get the last used voucher data after voucher_type_data is loaded
        const lastUsedVoucherData = getLastUsedVoucherData();

        // Use the last used voucher data or default to first voucher type
        const voucherDataToUse = lastUsedVoucherData.voucher_type_name
          ? lastUsedVoucherData
          : {
              voucher_type_name: voucherTypeResponse.data[0]?.voucher_type_name,
              voucher_type_id: voucherTypeResponse.data[0]?.id,
              voucher_number_series_id:
                voucherTypeResponse.data[0]?.vaucher_number_series_data[0]?.id,
            };

        // Update component state with the voucher data
        setData((prev) => ({
          ...prev,
          ...voucherDataToUse,
        }));

        // Fetch serial number
        const serialFormData = new FormData();
        serialFormData.append(
          "voucher_type_name",
          voucherDataToUse.voucher_type_name
        );
        serialFormData.append(
          "voucher_type_id",
          voucherDataToUse.voucher_type_id
        );
        serialFormData.append(
          "voucher_number_series_id",
          voucherDataToUse.voucher_number_series_id
        );
        serialFormData.append("company_id", userData?.id);

        const serialResponse = await dispatch(serialNumberList(serialFormData));

        setData((prev) => ({
          ...prev,
          serial_no: serialResponse.new_serial_no,
          check_num_series_manual_automatic: serialResponse?.data,
        }));

        setLoadingStates((prev) => ({ ...prev, vouchers: false }));
      } catch (error) {
        console.error("loadInitialData - Error:", error);
      }
    };

    loadInitialData();
  }, [
    userData?.id,
    voucher_type_data,
    dispatch,
    getLastUsedVoucherData, // Added missing dependency
  ]);

  // Handle case when component mounts with existing voucher_type_data
  useEffect(() => {
    if (
      voucher_type_data &&
      voucher_type_data.length > 0 &&
      !data.voucher_type_name &&
      !initialDataLoaded
    ) {
      const lastUsedVoucherData = getLastUsedVoucherData();

      if (lastUsedVoucherData.voucher_type_name) {
        setData((prev) => ({
          ...prev,
          voucher_type_name: lastUsedVoucherData.voucher_type_name,
          voucher_type_id: lastUsedVoucherData.voucher_type_id,
          voucher_number_series_id:
            lastUsedVoucherData.voucher_number_series_id,
        }));
        setInitialDataLoaded(true);
      }
    }
  }, [voucher_type_data, data.voucher_type_name, initialDataLoaded, getLastUsedVoucherData]);

  // Second useEffect for stock and location data
  useEffect(() => {
    const loadStockAndLocationData = async () => {
      if (!userData?.id) return;
      
      try {
        setLoadingStates((prev) => ({ ...prev, stock: true }));
        const formData = new FormData();
        formData.append("company_id", userData?.id);

        const [stockResponse, locationResponse] = await Promise.all([
          dispatch(stockItemList(formData)),
          dispatch(godownList(formData)),
        ]);

        if (stockResponse?.status) {
          setItemData(
            [{ id: 0, name: "End of List" }, ...stockResponse?.data] || []
          );
        }

        if (locationResponse?.status && locationResponse?.data) {
          const locationData = locationResponse.data;
          setgodownLocationItem(
            locationData[0]?.name === "Any"
              ? locationData.slice(1)
              : locationData
          );
          setgodownLocation([{ id: 0, name: "Any" }, ...locationData]);
        }
        setLoadingStates((prev) => ({ ...prev, stock: false }));
      } catch (error) {
      }
    };

    loadStockAndLocationData();
  }, [modal_state?.godownCreateVoucher, modal_state?.stockCreateVoucher, userData?.id]);

  // Modify the third useEffect for ledger data
  useEffect(() => {
    const loadLedgerData = async () => {
      if (!userData?.id) return;
      
      try {
        setLoadingStates((prev) => ({ ...prev, ledgers: true }));

        const fetchLedgerData = async (groupIds) => {
          const formData = new FormData();
          formData.append("group_ids", groupIds);
          formData.append("company_id", userData?.id);
          return await dispatch(contraLedgerListing(formData));
        };

        // Define ledger group combinations
        const ledgerGroups = [
          // Basic ledger groups
          `${userData?.group_data[4]?.id},${userData?.group_data[21]?.id},${userData?.group_data[5]?.id}`,
          "", // Empty group for receipt_particular_ledger_list
          `${userData?.group_data[0]?.id},${userData?.group_data[9]?.id},${userData?.group_data[13]?.id}`,
          `${userData?.group_data[26]?.id}`,
          `${userData?.group_data[25]?.id}`,

          // Complex ledger groups
          [3, 10, 14, 15, 11, 17, 18, 26]
            .map((i) => userData?.group_data[i]?.id)
            .join(","),
          [3, 10, 14, 15, 11, 17, 18, 25]
            .map((i) => userData?.group_data[i]?.id)
            .join(","),

          // Additional groups
          `${userData?.group_data[4]?.id},${userData?.group_data[21]?.id}`,
          `${userData?.group_data[5]?.id}`,
          `${userData?.group_data[9]?.id},${userData?.group_data[13]?.id}`,

          // All groups combined
          // Array.from({ length: 26 }, (_, i) => userData?.group_data[i + 1]?.id).join(',')
        ].filter((value) => value !== undefined && value !== null); // Only filter undefined/null, keep empty strings

        // Fetch all ledger data in parallel
        const results = await Promise.allSettled(
          ledgerGroups.map((groupIds) => fetchLedgerData(groupIds))
        );

        // State update mapping
        const stateUpdates = [
          { setter: setcontra_account_ledger_list, index: 0 },
          { setter: setreceipt_particular_ledger_list, index: 1 },
          { setter: setparty_bill_and_ship_to_ledger_list, index: 2 },
          { setter: setsales_ledger_list, index: 3 },
          { setter: setpurchase_ledger_list, index: 4 },
          { setter: setItemLedgerData, index: 5 },
          { setter: setItemLedgerPurchaseData, index: 6 },
          { setter: setbankAccountOdLedger, index: 7 },
          { setter: setcashInHandLedger, index: 8 },
          { setter: setsundryDebCredLedger, index: 9 },
        ];
        // Process results and update states
        stateUpdates.forEach(({ setter, index }) => {
          const result = results[index];
          if (result?.status === "fulfilled" && result.value?.data) {
            if (index === 5 || index === 6) {
              setter([
                { id: 0, ledger_name: "End of List" },
                ...result.value.data,
              ]);
            } else if (index === 9) {
              setpayment_allocation_ledger_list([
                { id: 0, ledger_name: "Not Applicable" },
                ...bankAccountOdLedger,
                ...cashInHandLedger,
                ...result.value.data,
              ]);
              setter([result.value.data]);
            } else {
              setter(result.value.data);
            }
          } else if (result?.status === "rejected") {
            console.error(
              `Failed to fetch ledger data for index ${index}:`,
              result.reason
            );
          }
        });
      } catch (error) {
      } finally {
        setLoadingStates((prev) => ({ ...prev, ledgers: false }));
      }
    };

    loadLedgerData();
  }, [
    modal_state?.ledgerCreate,
    userData?.id,
    dispatch,
  ]);

  // After initialState and data state are defined, update voucher_type based on voucher_type_name
  useEffect(() => {
    setData((prev) => ({
      ...prev,
      voucher_type:
        prev.voucher_type_name === "Sales"
          ? "sale"
          : prev.voucher_type_name === "Purchase"
          ? "purchase"
          : "",
    }));
  }, [data.voucher_type_name]);

  // Store last used voucher data whenever voucher type changes
  useEffect(() => {
    if (data.voucher_type_id && data.voucher_number_series_id) {
      storeLastUsedVoucherData(
        data.voucher_type_id,
        data.voucher_number_series_id
      );
    }
  }, [data.voucher_type_id, data.voucher_number_series_id]);

  const cleanString = (str) => str?.replace(/[^a-zA-Z0-9]/g, "")?.toLowerCase();

  const validations = {
    create_date: (value) => value.trim() !== "",
    account: (value) =>
      contra_account_ledger_list?.some((item) =>
        cleanString(item?.ledger_name)
          ?.toLowerCase()
          ?.includes(cleanString(value)?.toLowerCase())
      ),
  };

  // Fixed useEffect for loading voucher data by ID
  useEffect(() => {
    if (id && userData?.id) {
      const loadVoucherData = async () => {
        try {
          const formdata = new FormData();
          formdata.append('company_id', userData?.id);
          formdata.append('id', id);
          
          const response = await dispatch(contraVoucherSingle(formdata));
          
          if (response.status) {
            console.log(response?.data, "response?.data");
            setData({
              voucher_type_name: response?.data?.voucher_type_name,
              voucher_type_id: response?.data?.voucher_type_id,
              voucher_number_series_id: response?.data?.voucher_number_series_id,
              select_type_of_voucher: response?.data?.select_type_of_voucher,
              serial_no: response?.data?.serial_no,
              total_amount: response?.data?.total_amount,
              company_id: userData?.id,
              create_date: response?.data?.create_date,
              day_name: response?.data?.day_name,
              is_checked_series: "1",
              narration: response?.data?.narration,
              account: response?.data?.ledger_name,
              account_ledger_id: response?.data?.account_ledger_id,
              account_ledger_balance: response?.data?.account_ledger_balance,
              data: response?.data?.particular_data,
              is_proceed: "1",
              supplier_ref_no: response?.data?.supplier_ref_no,
              party_bill_to: response?.data?.party_bill_to_ledger_name,
              party_bill_to_ledger_id: response?.data?.party_bill_to_ledger_id,
              partry_bill_to_current_balance: response?.data?.party_bill_to_current_balance,
              data_item: response?.data?.data_item,
          
              sale_ledger_data: response?.data?.particular_sale_data,
              payment_allocation: [
                {
                  id: "1",
                  payment_ledger_account: "",
                  payment_ledger_account_id: "",
                  payment_ledger_amount: "",
                },
              ],
              party_bill_to_mailing_name: response?.data?.party_bill_to_mailing_name,
              bill_to_address: response?.data?.bill_to_address,
              bill_to_contact: response?.data?.bill_to_contact,
          
              party_ship_to: response?.data?.party_ship_to_ledger_name,
              party_ship_to_ledger_id: response?.data?.party_ship_to_ledger_id,
              party_ship_to_current_balance: response?.data?.party_ship_to_current_balance,
              party_ship_to_mailing_name: response?.data?.party_ship_to_mailing_name,
              ship_to_address: response?.data?.ship_to_address,
              ship_to_contact: response?.data?.ship_to_contact,
          
              sale_purchase_ledger_account: response?.data?.sale_purchase_ledger_account,
              sales_ledger_order_id: response?.data?.sales_ledger_order_id,
              sale_purchase_ledger_current_balance: response?.data?.sale_purchase_ledger_current_balance,
              dispatch_detail: response?.data?.dispatch_detail,
              voucher_type: response?.data?.voucher_type,
              delivery_note_no: response?.data?.delivery_note_no,
              dispatch_doc_no: response?.data?.dispatch_doc_no,
              dispatch_through: response?.data?.dispatch_through,
              destination: response?.data?.destination,
              carrier_name_agent: response?.data?.carrier_name_agent,
              bill_of_loading: response?.data?.bill_of_loading,
              dispatch_date: response?.data?.dispatch_date,
              order_detail: response?.data?.order_detail,
              order_no: response?.data?.order_no,
              mode_term_payment: response?.data?.mode_term_payment,
              other_reference: response?.data?.other_reference,
              term_of_delivery: response?.data?.term_of_delivery,
          
              location: response?.data?.location,
              location_id: response?.data?.location_id,
          
              bank_ac_od_ledger: response?.data?.bank_ac_od_ledger,
              bank_account_od_ledger: response?.data?.bank_account_od_ledger,
              bank_ac_amt: response?.data?.bank_ac_amt,
              UTR_CHQ: response?.data?.UTR_CHQ,
          
              cash_in_hand_ledger: response?.data?.cash_in_hand_ledger,
              cash_in_hand_ledger_name: response?.data?.cash_in_hand_ledger_name,
              cash_in_hand_amt: response?.data?.cash_in_hand_amt,
              cash_tendered: response?.data?.cash_tendered,
              balance: response?.data?.balance,
          
              sundry_debitor_ledger: response?.data?.sundry_debitor_ledger,
              sundry_debitor_amt: response?.data?.sundry_debitor_amt,
              sundry_debitor_ledger_name: response?.data?.sundry_debitor_ledger_name,
              tran_id: response?.data?.tran_id,
          
              party_account_ledger: response?.data?.party_account_ledger,
                party_account_name: response?.data?.party_account_name,
              party_amount: response?.data?.party_amount,
              party_balance: response?.data?.party_balance,
              total_item_amt: response?.data?.total_item_amt,
          
              date_payment: response?.data?.date_payment,
          
              check_num_series_manual_automatic: "",
              is_unit_available: "",
              where_unit_num: "",
              where_alternate_unit_num: "",
              alternate_unit_name: "",
              main_unit_name: "",
              combination_of_units: "",
              total_amount_item: "",
              total_amount_allocate_party: "",
            });
          }
        } catch (error) {
          console.error("Error loading voucher data:", error);
          toast.error("Failed to load voucher data", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      };

      loadVoucherData();
    }
  }, [id, userData?.id, dispatch]);

  const isAnyModalOpen =
    modal_state?.ledgerCreate ||
    modal_state?.godownCreateVoucher ||
    modal_state?.stockItemCreate ||
    modal_state?.period ||
    modal_state?.changeMode ||
    modal_state?.configure ||
    modal_state?.voucherTypeNameSelect ||
    modal_state?.dispatchDetails ||
    modal_state?.orderDetails ||
    modal_state?.otherVoucher;

  const refs = Object.keys(
    data?.voucher_type_name === "Sales" ||
      data?.voucher_type_name === "Purchase" ||
      data?.voucher_type_name === "Credit Note" ||
      data?.voucher_type_name === "Debit Note"
      ? inputRefs_sales
      : data?.voucher_type_name === "Receipt" ||
        data?.voucher_type_name === "Payment"
      ? inputRefs_reciept
      : inputRefs
  ).reduce((acc, name) => {
    acc[name] = {
      curr: getCurrentInputRef(name),
      onFocus: () => {
        if (["account"].includes(name)) {
          if (name) {
            dispatch(openModal(name));
          }
        }
        if (
          [
            "party_bill_to",
            "party_ship_to",
            "location",
            "sale_purchase_ledger_account",
            "dispatch_detail",
            "order_detail",
          ].includes(name)
        ) {
          if (name) {
            dispatch(openModal(name));
          }
        }
      },
      onBlur: (value) => {
        if (name === "account") {
          if (!value.trim()) {
            getCurrentInputRef(name)?.current?.focus();
          }
        }

        if (["account"].includes(name)) {
          if (name) {
            dispatch(closeModal(name));
          }
        }
        if (
          [
            "party_bill_to",
            "party_ship_to",
            "location",
            "sale_purchase_ledger_account",
            "dispatch_detail",
            "order_detail",
          ].includes(name)
        ) {
          if (name) {
            dispatch(closeModal(name));
          }
        }
      },
    };
    return acc;
  }, {});

  const {
    handleChange,
    handleFocus,
    handleBlur,
    handleKeyDown,
    setSubmitConfirm,
    submitConfirm,
    handleItemUpdate,
    handleKeyDownItem,
    handleDynamicFocus,
    handleDropdownClick,
    handleDropdownDynamicClick,
    handleDynamicBlur,
  } = useInputActionVoucher({
    data,
    setData,
    contra_account_ledger_list:
      data?.voucher_type_name === "Receipt" ||
      data?.voucher_type_name === "Payment"
        ? receipt_particular_ledger_list
        : contra_account_ledger_list,
    itemData,
    validations,
    refs,
    check_dropdown:
      modal_state?.account ||
      modal_state?.party_bill_to_create ||
      modal_state?.party_ship_to_create,
    inputRefs:
      data?.voucher_type_name === "Receipt" ||
      data?.voucher_type_name === "Payment"
        ? inputRefs_reciept
        : data?.voucher_type_name === "Sales" ||
          data?.voucher_type_name === "Purchase" ||
          data?.voucher_type_name === "Credit Note" ||
          data?.voucher_type_name === "Debit Note"
        ? inputRefs_sales
        : inputRefs,
    dynamicInputRef:
      data?.voucher_type_name === "Sales" ||
      data?.voucher_type_name === "Purchase" ||
      data?.voucher_type_name === "Credit Note" ||
      data?.voucher_type_name === "Debit Note"
        ? dynamicInputRef_sales
        : dynamicInputRef,
    dynamicInputRef_payment_allocation:
      data?.voucher_type_name === "Sales" ||
      data?.voucher_type_name === "Purchase" ||
      data?.voucher_type_name === "Credit Note" ||
      data?.voucher_type_name === "Debit Note"
        ? dynamicInputRef_payment_allocation
        : dynamicInputRef,
    setNameInput,
    itemLedgerData,
  });

  const validateForm = () => {
    // Basic required field validations
    const requiredFields = [
      { field: "voucher_type_name", message: "Voucher type is required" },
      { field: "serial_no", message: "Serial number is required" },
      { field: "create_date", message: "Date is required" },
    ];

    // Check basic required fields
    for (let { field, message } of requiredFields) {
      if (!data?.[field] || data[field].toString().trim() === "") {
        toast.error(message, {
          position: toast.POSITION.TOP_CENTER,
        });
        setSubmitConfirm("");
        // Focus on the first field that fails validation
        focusOnField(field);
        return false;
      }
    }

    // Validate based on voucher type
    switch (data?.voucher_type_name) {
      case "Sales":
      case "Purchase":
      case "Credit Note":
      case "Debit Note":
        return validateSalesPurchaseVoucher();
      case "Receipt":
      case "Payment":
        return validateReceiptPaymentVoucher();
      case "Contra":
        return validateContraVoucher();
      default:
        toast.error("Invalid voucher type", {
          position: toast.POSITION.TOP_CENTER,
        });
        setSubmitConfirm("");
        return false;
    }
  };

  // Helper function to focus on a specific field
  const focusOnField = (fieldName) => {
    // Determine which input refs to use based on voucher type
    const currentRefs = (() => {
      switch (data?.voucher_type_name) {
        case "Sales":
        case "Purchase":
        case "Credit Note":
        case "Debit Note":
          return inputRefs_sales;
        case "Receipt":
        case "Payment":
          return inputRefs_reciept;
        case "Contra":
          return inputRefs;
        default:
          return inputRefs;
      }
    })();

    // Focus on the field
    if (currentRefs?.[fieldName]?.current) {
      setTimeout(() => {
        currentRefs[fieldName].current.focus();
        if (currentRefs[fieldName].current.value) {
          currentRefs[fieldName].current.setSelectionRange(
            0,
            currentRefs[fieldName].current.value.length
          );
        }
      }, 100);
    }
  };

  // Helper function to focus on dynamic field
  const focusOnDynamicField = (fieldName, index = 0) => {
    // Determine which dynamic input refs to use based on voucher type
    const currentDynamicRefs = (() => {
      switch (data?.voucher_type_name) {
        case "Sales":
        case "Purchase":
        case "Credit Note":
        case "Debit Note":
          return dynamicInputRef_sales;
        default:
          return dynamicInputRef;
      }
    })();

    // Focus on the dynamic field
    if (currentDynamicRefs?.current?.[`${fieldName}${index}`]) {
      setTimeout(() => {
        currentDynamicRefs.current[`${fieldName}${index}`].focus();
        if (currentDynamicRefs.current[`${fieldName}${index}`].value) {
          currentDynamicRefs.current[`${fieldName}${index}`].setSelectionRange(
            0,
            currentDynamicRefs.current[`${fieldName}${index}`].value.length
          );
        }
      }, 100);
    }
  };

  // Validate Sales/Purchase vouchers
  const validateSalesPurchaseVoucher = () => {
    // Check required fields for Sales/Purchase
    const requiredFields = [
      { field: "party_bill_to", message: "Party (Bill To) is required" },
      { field: "party_ship_to", message: "Party (Ship To) is required" },
      { field: "location", message: "Location is required" },
      {
        field: "sale_purchase_ledger_account",
        message: "Sales/Purchase Ledger is required",
      },
    ];

    for (let { field, message } of requiredFields) {
      if (!data?.[field] || data[field].toString().trim() === "") {
        toast.error(message, {
          position: toast.POSITION.TOP_CENTER,
        });
        setSubmitConfirm("");
        focusOnField(field);
        return false;
      }
    }

    // Validate data_item entries
    if (!data?.data_item || data.data_item.length === 0) {
      toast.error("At least one item entry is required", {
        position: toast.POSITION.TOP_CENTER,
      });
      setSubmitConfirm("");
      focusOnDynamicField("item_name", 0);
      return false;
    }

    // Check if all entries are empty or have zero amounts
    const validEntries = data.data_item.filter((item) => {
      // Check if item has any meaningful data
      const hasItemName =
        item?.item_name && item.item_name.toString().trim() !== "";
      const hasItemId = item?.item_id && item.item_id.toString().trim() !== "";
      const hasAmount = item?.item_amt && parseFloat(item.item_amt) > 0;

      return hasItemName && hasItemId && hasAmount;
    });

    if (validEntries.length === 0) {
      // Find the first invalid entry and focus on it
      for (let i = 0; i < data.data_item.length; i++) {
        const item = data.data_item[i];
        if (!item?.item_name || item.item_name.toString().trim() === "") {
          toast.error(
            "At least one valid item entry with amount greater than 0 is required",
            {
              position: toast.POSITION.TOP_CENTER,
            }
          );
          setSubmitConfirm("");
          focusOnDynamicField("item_name", i);
          return false;
        }
        if (!item?.item_id || item.item_id.toString().trim() === "") {
          toast.error(
            "At least one valid item entry with amount greater than 0 is required",
            {
              position: toast.POSITION.TOP_CENTER,
            }
          );
          setSubmitConfirm("");
          focusOnDynamicField("item_name", i);
          return false;
        }
        if (!item?.item_amt || parseFloat(item.item_amt) <= 0) {
          toast.error(
            "At least one valid item entry with amount greater than 0 is required",
            {
              position: toast.POSITION.TOP_CENTER,
            }
          );
          setSubmitConfirm("");
          focusOnDynamicField("item_amt", i);
          return false;
        }
      }
    }

    // Check if total amount is greater than 0
    const totalAmount = data.data_item.reduce((sum, item) => {
      return sum + (parseFloat(item?.item_amt) || 0);
    }, 0);

    if (totalAmount <= 0) {
      toast.error("Total amount must be greater than 0", {
        position: toast.POSITION.TOP_CENTER,
      });
      setSubmitConfirm("");
      // Focus on the first item amount field
      focusOnDynamicField("item_amt", 0);
      return false;
    }

    return true;
  };

  // Validate Receipt/Payment vouchers
  const validateReceiptPaymentVoucher = () => {
    // Check required fields for Receipt/Payment
    const requiredFields = [
      { field: "account", message: "Account is required" },
    ];

    for (let { field, message } of requiredFields) {
      if (!data?.[field] || data[field].toString().trim() === "") {
        toast.error(message, {
          position: toast.POSITION.TOP_CENTER,
        });
        setSubmitConfirm("");
        focusOnField(field);
        return false;
      }
    }

    // Validate data entries
    if (!data?.data || data.data.length === 0) {
      toast.error("At least one entry is required", {
        position: toast.POSITION.TOP_CENTER,
      });
      setSubmitConfirm("");
      focusOnDynamicField("first", 0);
      return false;
    }

    // Check if all entries are empty or have zero amounts
    const validEntries = data.data.filter((item) => {
      // Check if item has any meaningful data
      const hasFirst = item?.first && item.first.toString().trim() !== "";
      const hasLedgerId =
        item?.particular_ledger_id &&
        item.particular_ledger_id.toString().trim() !== "";
      const hasAmount =
        item?.particular_ledger_pay_amount &&
        parseFloat(item.particular_ledger_pay_amount) > 0;

      return hasFirst && hasLedgerId && hasAmount;
    });

    if (validEntries.length === 0) {
      // Find the first invalid entry and focus on it
      for (let i = 0; i < data.data.length; i++) {
        const item = data.data[i];
        if (!item?.first || item.first.toString().trim() === "") {
          toast.error(
            "At least one valid entry with amount greater than 0 is required",
            {
              position: toast.POSITION.TOP_CENTER,
            }
          );
          setSubmitConfirm("");
          focusOnDynamicField("first", i);
          return false;
        }
        if (
          !item?.particular_ledger_id ||
          item.particular_ledger_id.toString().trim() === ""
        ) {
          toast.error(
            "At least one valid entry with amount greater than 0 is required",
            {
              position: toast.POSITION.TOP_CENTER,
            }
          );
          setSubmitConfirm("");
          focusOnDynamicField("first", i);
          return false;
        }
        if (
          !item?.particular_ledger_pay_amount ||
          parseFloat(item.particular_ledger_pay_amount) <= 0
        ) {
          toast.error(
            "At least one valid entry with amount greater than 0 is required",
            {
              position: toast.POSITION.TOP_CENTER,
            }
          );
          setSubmitConfirm("");
          focusOnDynamicField("particular_ledger_pay_amount", i);
          return false;
        }
      }
    }

    // Check if total amount is greater than 0
    const totalAmount = data.data.reduce((sum, item) => {
      return sum + (parseFloat(item?.particular_ledger_pay_amount) || 0);
    }, 0);

    if (totalAmount <= 0) {
      toast.error("Total amount must be greater than 0", {
        position: toast.POSITION.TOP_CENTER,
      });
      setSubmitConfirm("");
      // Focus on the first amount field
      focusOnDynamicField("particular_ledger_pay_amount", 0);
      return false;
    }

    return true;
  };

  // Validate Contra vouchers
  const validateContraVoucher = () => {
    // Check required fields for Contra
    const requiredFields = [
      { field: "account", message: "Account is required" },
    ];

    for (let { field, message } of requiredFields) {
      if (!data?.[field] || data[field].toString().trim() === "") {
        toast.error(message, {
          position: toast.POSITION.TOP_CENTER,
        });
        setSubmitConfirm("");
        focusOnField(field);
        return false;
      }
    }

    // Validate data entries
    if (!data?.data || data.data.length === 0) {
      toast.error("At least one entry is required", {
        position: toast.POSITION.TOP_CENTER,
      });
      setSubmitConfirm("");
      focusOnDynamicField("first", 0);
      return false;
    }

    // Check if all entries are empty or have zero amounts
    const validEntries = data.data.filter((item) => {
      // Check if item has any meaningful data
      const hasFirst = item?.first && item.first.toString().trim() !== "";
      const hasLedgerId =
        item?.particular_ledger_id &&
        item.particular_ledger_id.toString().trim() !== "";
      const hasAmount =
        item?.particular_ledger_pay_amount &&
        parseFloat(item.particular_ledger_pay_amount) > 0;

      return hasFirst && hasLedgerId && hasAmount;
    });

    if (validEntries.length === 0) {
      // Find the first invalid entry and focus on it
      for (let i = 0; i < data.data.length; i++) {
        const item = data.data[i];
        if (!item?.first || item.first.toString().trim() === "") {
          toast.error(
            "At least one valid entry with amount greater than 0 is required",
            {
              position: toast.POSITION.TOP_CENTER,
            }
          );
          setSubmitConfirm("");
          focusOnDynamicField("first", i);
          return false;
        }
        if (
          !item?.particular_ledger_id ||
          item.particular_ledger_id.toString().trim() === ""
        ) {
          toast.error(
            "At least one valid entry with amount greater than 0 is required",
            {
              position: toast.POSITION.TOP_CENTER,
            }
          );
          setSubmitConfirm("");
          focusOnDynamicField("first", i);
          return false;
        }
        if (
          !item?.particular_ledger_pay_amount ||
          parseFloat(item.particular_ledger_pay_amount) <= 0
        ) {
          toast.error(
            "At least one valid entry with amount greater than 0 is required",
            {
              position: toast.POSITION.TOP_CENTER,
            }
          );
          setSubmitConfirm("");
          focusOnDynamicField("particular_ledger_pay_amount", i);
          return false;
        }
      }
    }

    // Check if total amount is greater than 0
    const totalAmount = data.data.reduce((sum, item) => {
      return sum + (parseFloat(item?.particular_ledger_pay_amount) || 0);
    }, 0);

    if (totalAmount <= 0) {
      toast.error("Total amount must be greater than 0", {
        position: toast.POSITION.TOP_CENTER,
      });
      setSubmitConfirm("");
      // Focus on the first amount field
      focusOnDynamicField("particular_ledger_pay_amount", 0);
      return false;
    }

    return true;
  };

  const resetForm = async () => {
    try {
      // Get the last used voucher data from localStorage
      const lastUsedData = localStorage.getItem("lastUsedVoucherData");
      let storedData = {
        voucher_type_name: "",
        voucher_type_id: "",
        voucher_number_series_id: "",
      };

      if (lastUsedData) {
        try {
          const parsedData = JSON.parse(lastUsedData);
          const lastUsedVoucherData = getLastUsedVoucherData();
          storedData = {
            voucher_type_name: lastUsedVoucherData.voucher_type_name,
            voucher_type_id: lastUsedVoucherData.voucher_type_id,
            voucher_number_series_id:
              lastUsedVoucherData.voucher_number_series_id,
          };
        } catch (error) {
          console.error(
            "Error parsing lastUsedVoucherData in resetForm:",
            error
          );
        }
      }

      // If no last used data, use current data or default to first voucher type
      if (!storedData.voucher_type_name) {
        storedData = {
          voucher_type_name:
            data?.voucher_type_name ||
            voucher_type_data?.[0]?.voucher_type_name,
          voucher_type_id: data?.voucher_type_id || voucher_type_data?.[0]?.id,
          voucher_number_series_id:
            data?.voucher_number_series_id ||
            voucher_type_data?.[0]?.vaucher_number_series_data?.[0]?.id,
        };
      }

      const serialFormData = new FormData();
      serialFormData.append("voucher_type_name", storedData.voucher_type_name);
      serialFormData.append("voucher_type_id", storedData.voucher_type_id);
      serialFormData.append(
        "voucher_number_series_id",
        storedData.voucher_number_series_id
      );
      if (userData?.id) {
        serialFormData.append("company_id", userData.id);
      }

      const serialResponse = await dispatch(serialNumberList(serialFormData));
      dynamicInputRef.current = {};
      dynamicInputRef_sales.current = {};
      setData({
        ...initialState,
        ...storedData,
        serial_no: serialResponse?.new_serial_no,
        check_num_series_manual_automatic: serialResponse?.data,
      });

    } catch (error) {
      console.error("Error resetting form:", error);
    }
  };

  const { handleSubmit, loading, handleFocusReset } = useFormHandler({
    validateForm,
    prepareFormData: () => prepareFormData(data),
    submitForm: (data) => dispatch(contraVoucherCreate(data)),
    shortcuts: [
      {
        key: "a",
        ctrlKey: true,
        action: () => handleSubmit(new Event("submit")),
      },
    ],
    resetForm,
    first_ref:
      data?.voucher_type_name === "Sales" ||
      data?.voucher_type_name === "Purchase" ||
      data?.voucher_type_name === "Credit Note" ||
      data?.voucher_type_name === "Debit Note"
        ? inputRefs_sales?.create_date
        : data?.voucher_type_name === "Receipt" ||
          data?.voucher_type_name === "Payment"
        ? inputRefs_reciept?.create_date
        : data?.voucher_type_name === "Contra"
        ? inputRefs?.create_date
        : null,
    // closeModal: closeModal_sec,
    setSubmitConfirm,
    submitConfirm,
    setData,
    data,
  });

  const handleClickOutside = (event) => {
    if (nameInput?.current) {
      event.preventDefault();
      nameInput.current.focus();
    } else if (nameInput?.focus) {
      event.preventDefault();
      nameInput.focus();
    }
  };

  const handleClickInside = (event) => {
    let clickedElement = event.target;
    if (
      clickedElement?.tagName &&
      (clickedElement?.tagName.toLowerCase() === "input" ||
        clickedElement?.tagName.toLowerCase() === "textarea")
    ) {
      clickedElement.focus();
    }
  };

  useClickOutside(nameInput, handleClickOutside, handleClickInside);

  useEffect(() => {
    if (nameInput?.current) {
      nameInput.current.focus();
      if (nameInput.value) {
        nameInput.setSelectionRange(0, nameInput.value.length);
      }
    }
  }, [
    modal_state?.ledgerCreate,
    modal_state?.godownCreateVoucher,
    modal_state?.stockItemCreate,
  ]);

  useEffect(() => {
    // If any modal is open, don't add keyboard event listeners
    if (isAnyModalOpen) {
      return;
    }

    const handleKeyPress = (event) => {
      // Double check - if any modal is open, don't handle keyboard events
      if (isAnyModalOpen) {
        return;
      }

      if (event.altKey && event.key === "c") {
        // Get the current active element
        const activeElement = document.activeElement;

        // Determine which input refs to use based on voucher type
        const currentRefs = (() => {
          switch (data?.voucher_type_name) {
            case "Sales":
            case "Purchase":
            case "Credit Note":
            case "Debit Note":
              return inputRefs_sales;
            case "Receipt":
            case "Payment":
              return inputRefs_reciept;
            case "Contra":
              return inputRefs;
            default:
              return inputRefs;
          }
        })();

        // Check which input is focused and dispatch appropriate modal
        if (activeElement === currentRefs?.account?.current) {
          dispatch(openModal("ledgerCreate"));
        } else if (activeElement === currentRefs?.party_bill_to?.current) {
          dispatch(openModal("ledgerCreate"));
        } else if (activeElement === currentRefs?.party_ship_to?.current) {
          dispatch(openModal("ledgerCreate"));
        } else if (activeElement === currentRefs?.location?.current) {
          dispatch(openModal("godownCreateVoucher"));
        } else if (
          activeElement === currentRefs?.sale_purchase_ledger_account?.current
        ) {
          dispatch(openModal("ledgerCreate"));
        }

        // Check for dynamic fields
        const dynamicRefs = (() => {
          switch (data?.voucher_type_name) {
            case "Sales":
            case "Purchase":
            case "Credit Note":
            case "Debit Note":
              return dynamicInputRef_sales;
            default:
              return dynamicInputRef;
          }
        })();

        // Check if the active element is a dynamic input field
        if (dynamicRefs.current) {
          const dynamicFieldKeys = Object.keys(dynamicRefs.current);
          for (const key of dynamicFieldKeys) {
            if (activeElement === dynamicRefs.current[key]) {
              // Extract field name and index from the key (e.g., "first0", "ledger_account1")
              const fieldMatch = key.match(/^([a-zA-Z_]+)(\d+)$/);
              if (fieldMatch) {
                const [, fieldName, index] = fieldMatch;

                // Determine which modal to open based on field type
                if (fieldName === "first" || fieldName === "ledger_account") {
                  dispatch(openModal("ledgerCreate"));
                } else if (fieldName === "item_name") {
                  // For item fields, open stock item creation modal
                  dispatch(openModal("stockItemCreate"));
                } else if (fieldName === "godown_location") {
                  dispatch(openModal("godownCreateVoucher"));
                }
              }
              break;
            }
          }
        }
      }
      if (event.ctrlKey && (event.key === "h" || event.key === "H")) {
        event.preventDefault();
        dispatch(openModal("changeMode"));
      }
      if (event.key === "F2") {
        event.preventDefault();
        dispatch(openModal("period"));
      }
      if (event.key === "F10") {
        event.preventDefault();
        dispatch(openModal("otherVoucher"));
      }
      if (event.key === "F12") {
        event.preventDefault();
        dispatch(openModal("configure"));
      }
    };

    window.addEventListener("keydown", handleKeyPress);
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [
    isAnyModalOpen,
    data?.voucher_type_name,
    inputRefs,
    inputRefs_sales,
    inputRefs_reciept,
    dynamicInputRef,
    dynamicInputRef_sales,
  ]);

  const displayNameOfVoucherType = (name, voucher_type_data) => {
    setLoading_voucher(true);
    filter_voucher = voucher_type_data?.filter((item) => {
      return (
        item?.select_type_of_voucher?.replace(/\s/g, "") ===
        name?.replace(/\s/g, "")
      );
    });
    if (filter_voucher?.length > 1) {
      dispatch(filterVoucherTypeData(filter_voucher));
      dispatch(openModal("voucherTypeNameSelect"));
      setLoading_voucher(false);
    } else {
      if (filter_voucher[0]?.vaucher_number_series_data?.length > 1) {
        dispatch(filterVoucherTypeData(filter_voucher));
        numberlistfun(filter_voucher[0]?.voucher_type_name);
        dispatch(openModal("voucherTypeNameSelect"));
        setLoading_voucher(false);
      } else {
        const serial = new FormData();
        serial.append(
          "voucher_type_name",
          filter_voucher[0]?.voucher_type_name
        );
        serial.append(
          "voucher_number_series_id",
          filter_voucher[0]?.vaucher_number_series_data[0]?.id
        );
        serial.append("company_id", userData?.id);
        dispatch(serialNumberList(serial))
          .then((response) => {
            if (response.status) {
              setData({
                ...data,
                voucher_type_name: name,
                voucher_type_id: filter_voucher[0]?.id,
                serial_no: response.new_serial_no,
                voucher_number_series_id:
                  filter_voucher[0]?.vaucher_number_series_data[0]?.id,
              });
              setLoading_voucher(false);
            }
          })
          .catch((e) => {
            console.log(e);
          });
      }
      storeLastUsedVoucherData(
        filter_voucher[0]?.id,
        filter_voucher[0]?.vaucher_number_series_data[0]?.id
      );
    }
  };

  // Store last used entry name and voucher number series in localStorage
  const storeLastUsedVoucherData = (
    voucher_type_id,
    voucher_number_series_id
  ) => {
    localStorage.setItem(
      "lastUsedVoucherData",
      JSON.stringify({
        voucher_type_id,
        voucher_number_series_id,
      })
    );
  };

  const numberlistfun = (name) => {
    const formdata = new FormData();
    formdata.append("voucher_type_name", name);
    formdata.append("company_id", userData?.id);
    dispatch(numberSeriesList(formdata)).then((response) => {
    });
  };

  return (
    <HomeLayout
      data={data}
      setData={setData}
      displayNameOfVoucherType={displayNameOfVoucherType}
    >
      {loadingStates.vouchers ||
      loadingStates.stock ||
      loadingStates.ledgers ? (
        <Indicator />
      ) : (
        <>
          {modal_state?.ledgerCreate ||
          modal_state?.godownCreateVoucher ||
          modal_state?.stockItemCreate ? (
            <>
              {modal_state?.ledgerCreate ? (
                <div style={{ zIndex: 10000 }}>
                  <LedgerCreate
                    title="Ledger Creation (Secondary)"
                    closeModal_sec={() => dispatch(closeModal("ledgerCreate"))}
                  />
                </div>
              ) : null}
              {modal_state?.godownCreateVoucher ? (
                <div style={{ zIndex: 10000 }}>
                  <GodownCreate
                    title="Godown Creation (Secondary)"
                    closeModal_sec={() =>
                      dispatch(closeModal("godownCreateVoucher"))
                    }
                  />
                </div>
              ) : null}
              {modal_state?.stockItemCreate ? (
                <div style={{ zIndex: 10000 }}>
                  <StockItemCreate
                    title="Stock Item Creation (Secondary)"
                    closeModal_sec={() =>
                      dispatch(closeModal("stockItemCreate"))
                    }
                  />
                </div>
              ) : null}
            </>
          ) : null}

          {modal_state?.period ? (
            <div style={{ zIndex: 10000 }}>
              <Period
                setData={setData}
                data={data}
              />
            </div>
          ) : null}
          {modal_state?.changeMode ? (
            <div style={{ zIndex: 10000 }}>
              <ChangeMode
                setData={setData}
                data={data}
              />
            </div>
          ) : null}
          {modal_state?.configure ? (
            <div style={{ zIndex: 10000 }}>
              <Configure
                setData={setData}
                data={data}
              />
            </div>
          ) : null}
          {modal_state?.voucherTypeNameSelect ? (
            <div style={{ zIndex: 10000 }}>
              <VoucherTypeNameSelect
                loading_voucher={loading_voucher}
                setLoading_voucher={setLoading_voucher}
                setData={setData}
                data={data}
              />
            </div>
          ) : null}
          {modal_state?.dispatchDetails ? (
            <div style={{ zIndex: 10000 }}>
              <DispatchDetails
                setData={setData}
                data={data}
              />
            </div>
          ) : null}
          {modal_state?.orderDetails ? (
            <div style={{ zIndex: 10000 }}>
              <OrderDetails
                setData={setData}
                data={data}
              />
            </div>
          ) : null}
          {modal_state?.otherVoucher ? (
            <div style={{ zIndex: 10000 }}>
              <OtherVoucher
                setData={setData}
                data={data}
                displayNameOfVoucherType={displayNameOfVoucherType}
              />
            </div>
          ) : null}
          {data?.voucher_type_name === "Contra" ||
          data?.select_type_of_voucher === "Contra" ? (
            <Contra
              loading_voucher={loading_voucher}
              data={data}
              setData={setData}
              initialState={initialState}
              contra_account_ledger_list={contra_account_ledger_list}
              handleChange={handleChange}
              handleFocus={handleFocus}
              handleBlur={handleBlur}
              handleKeyDown={handleKeyDown}
              handleItemUpdate={handleItemUpdate}
              handleKeyDownItem={handleKeyDownItem}
              handleDynamicFocus={handleDynamicFocus}
              handleDropdownClick={handleDropdownClick}
              handleDropdownDynamicClick={handleDropdownDynamicClick}
              handleDynamicBlur={handleDynamicBlur}
              handleSubmit={handleSubmit}
              loading={loading}
              handleFocusReset={handleFocusReset}
              setSubmitConfirm={setSubmitConfirm}
              submitConfirm={submitConfirm}
              inputRefs={inputRefs}
              dynamicInputRef={dynamicInputRef}
              modal_state={modal_state}
            />
          ) : data?.voucher_type_name === "Journal" ||
            data?.select_type_of_voucher === "Journal" ? (
            <Journal
              loading_voucher={loading_voucher}
              data={data}
              setData={setData}
              handleChange={handleChange}
              handleFocus={handleFocus}
              handleBlur={handleBlur}
              handleKeyDown={handleKeyDown}
              handleItemUpdate={handleItemUpdate}
              handleKeyDownItem={handleKeyDownItem}
              handleDynamicFocus={handleDynamicFocus}
              handleDropdownClick={handleDropdownClick}
              handleDropdownDynamicClick={handleDropdownDynamicClick}
              handleDynamicBlur={handleDynamicBlur}
              handleSubmit={handleSubmit}
              loading={loading}
              handleFocusReset={handleFocusReset}
              setSubmitConfirm={setSubmitConfirm}
              submitConfirm={submitConfirm}
              inputRefs={inputRefs}
              dynamicInputRef={dynamicInputRef}
              modal_state={modal_state}
            />
          ) : data?.voucher_type_name === "Receipt" ||
            data?.voucher_type_name === "Payment" ||
            data?.select_type_of_voucher === "Receipt" ||
            data?.select_type_of_voucher === "Payment" ? (
            <RecieptPayment
              loading_voucher={loading_voucher}
              data={data}
              setData={setData}
              initialState={initialState}
              contra_account_ledger_list={contra_account_ledger_list}
              ledger_list={receipt_particular_ledger_list}
              handleChange={handleChange}
              handleFocus={handleFocus}
              handleBlur={handleBlur}
              handleKeyDown={handleKeyDown}
              handleItemUpdate={handleItemUpdate}
              handleKeyDownItem={handleKeyDownItem}
              handleDynamicFocus={handleDynamicFocus}
              handleDropdownClick={handleDropdownClick}
              handleDropdownDynamicClick={handleDropdownDynamicClick}
              handleDynamicBlur={handleDynamicBlur}
              handleSubmit={handleSubmit}
              loading={loading}
              handleFocusReset={handleFocusReset}
              setSubmitConfirm={setSubmitConfirm}
              submitConfirm={submitConfirm}
              inputRefs={inputRefs_reciept}
              dynamicInputRef={dynamicInputRef}
              modal_state={modal_state}
            />
          ) : data?.voucher_type_name === "Sales" ||
            data?.select_type_of_voucher === "Sales" ||
            data?.voucher_type_name === "Credit Note" ||
            data?.select_type_of_voucher === "Credit Note" ? (
            <Sales
              loading_voucher={loading_voucher}
              data={data}
              setData={setData}
              itemData={itemData}
              godownLocation={godownLocation}
              godownLocationItem={godownLocationItem}
              itemLedgerData={itemLedgerData}
              payment_allocation_ledger_list={payment_allocation_ledger_list}
              itemLedgerPurchaseData={itemLedgerPurchaseData}
              party_bill_and_ship_to_ledger_list={
                party_bill_and_ship_to_ledger_list
              }
              sales_ledger_list={sales_ledger_list}
              purchase_ledger_list={purchase_ledger_list}
              bankAccountOdLedger={bankAccountOdLedger}
              cashInHandLedger={cashInHandLedger}
              sundryDebCredLedger={sundryDebCredLedger}
              handleChange={handleChange}
              handleFocus={handleFocus}
              handleBlur={handleBlur}
              handleKeyDown={handleKeyDown}
              handleItemUpdate={handleItemUpdate}
              handleKeyDownItem={handleKeyDownItem}
              handleDynamicFocus={handleDynamicFocus}
              handleDropdownClick={handleDropdownClick}
              handleDropdownDynamicClick={handleDropdownDynamicClick}
              handleDynamicBlur={handleDynamicBlur}
              handleSubmit={handleSubmit}
              loading={loading}
              handleFocusReset={handleFocusReset}
              setSubmitConfirm={setSubmitConfirm}
              submitConfirm={submitConfirm}
              inputRefs={inputRefs_sales}
              dynamicInputRef={dynamicInputRef_sales}
              dynamicInputRef_payment_allocation={
                dynamicInputRef_payment_allocation
              }
              modal_state={modal_state}
            />
          ) : data?.voucher_type_name === "Purchase" ||
            data?.select_type_of_voucher === "Purchase" ||
            data?.voucher_type_name === "Debit Note" ||
            data?.select_type_of_voucher === "Debit Note" ? (
            <Purchase
              loading_voucher={loading_voucher}
              data={data}
              setData={setData}
              itemData={itemData}
              godownLocation={godownLocation}
              godownLocationItem={godownLocationItem}
              itemLedgerData={itemLedgerData}
              payment_allocation_ledger_list={payment_allocation_ledger_list}
              itemLedgerPurchaseData={itemLedgerPurchaseData}
              party_bill_and_ship_to_ledger_list={
                party_bill_and_ship_to_ledger_list
              }
              sales_ledger_list={sales_ledger_list}
              purchase_ledger_list={purchase_ledger_list}
              bankAccountOdLedger={bankAccountOdLedger}
              cashInHandLedger={cashInHandLedger}
              sundryDebCredLedger={sundryDebCredLedger}
              handleChange={handleChange}
              handleFocus={handleFocus}
              handleBlur={handleBlur}
              handleKeyDown={handleKeyDown}
              handleItemUpdate={handleItemUpdate}
              handleKeyDownItem={handleKeyDownItem}
              handleDynamicFocus={handleDynamicFocus}
              handleDropdownClick={handleDropdownClick}
              handleDropdownDynamicClick={handleDropdownDynamicClick}
              handleDynamicBlur={handleDynamicBlur}
              handleSubmit={handleSubmit}
              loading={loading}
              handleFocusReset={handleFocusReset}
              setSubmitConfirm={setSubmitConfirm}
              submitConfirm={submitConfirm}
              inputRefs={inputRefs_sales}
              dynamicInputRef={dynamicInputRef_sales}
              dynamicInputRef_payment_allocation={
                dynamicInputRef_payment_allocation
              }
              modal_state={modal_state}
            />
          ) : null}
        </>
      )}
    </HomeLayout>
  );
});

export default Vouchers;
